import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import PermissionService from 'components/Common/PermissionService';
import React, { useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import UnpublishQuestionDialog
  from 'components/CleanRooms/CurrentQuestions/UnpublishQuestionDialog';
import { CLEAN_ROOM_STATUS } from 'components/CleanRooms/constants';
import { DropdownMenu } from 'BaseComponents/DropdownMenu';
import { QUESTION_STATUS } from 'utils/constants/question.constant';
import { cleanRoomPermissions, productPerm } from 'utils/appConstants';
import { useSelector } from 'react-redux';


const QuestionStatus = ({ question, handlePublish, handleUnpublish }) => {
  const [openUnpublishDialog, setOpenUnpublishDialog] = useState(false);
  const hasQuestionBuilderPermission = PermissionService.isAuthorized([
    cleanRoomPermissions.questionBuilder]);
  const crDetail = useSelector(state => state.cleanRooms.detail);
  const isExpired = crDetail?.status === CLEAN_ROOM_STATUS.EXPIRED.key;

  const unpublishQuestionEnabled = PermissionService.isProductEnabled(
    [productPerm.UnpublishQuestion],
  );

  const onHandlePublish = (questionId) => {
    handlePublish(questionId);
  };

  const onHandleUnpublish = () => {
    setOpenUnpublishDialog(!openUnpublishDialog);
  };

  let itemsPublishMenu = [{
    label: 'Publish',
    action: () => onHandlePublish(question.questionID),
  }];

  if (isExpired) {
    itemsPublishMenu = [];
  }
  const publishDisabledTooltip = isExpired ? 'Clean Room Expired. Unable to publish.' : '';

  // default status UI as stage with version
  let statusUI = <Typography>{`${QUESTION_STATUS.STAGE.value} v${question.questionVersion}`}</Typography>;

  // if question is in stage and user has QB permission, show publish dropdown if has permission
  if (question.questionStatus === QUESTION_STATUS.STAGE.key) {
    if (hasQuestionBuilderPermission) {
      statusUI = (
        <Tooltip title={publishDisabledTooltip}>
          <span>
            <DropdownMenu
              variant='outlined'
              icon={<ArrowDropDownIcon />}
              label={`${QUESTION_STATUS.STAGE.value} v${question.questionVersion}`}
              size='small'
              menuItems={itemsPublishMenu}
            />
          </span>
        </Tooltip>
      );
    }
  }

  /**
   * if question is published and unpublish FF is enabled and user has QB permission,
   * show unpublish dropdown
   */
  if (question.questionStatus === QUESTION_STATUS.PUBLISHED.key) {
    if (unpublishQuestionEnabled && hasQuestionBuilderPermission) {
      const itemsUnPublishMenu = [{
        label: 'UnPublish',
        action: () => onHandleUnpublish(question.questionID),
      }];
      statusUI = (
        <span>
          <DropdownMenu
            variant='outlined'
            icon={<ArrowDropDownIcon />}
            label={`${QUESTION_STATUS.PUBLISHED.value}`}
            size='small'
            menuItems={itemsUnPublishMenu}
          />
        </span>
      );
    }
    else {
      statusUI = (
        <Tooltip placement='top-start' title={QUESTION_STATUS.PUBLISHED.value}>
          <Typography
            noWrap
            variant='body2'
            style={{
              padding: '5px 5px',
              height: '27px',
            }}
          >
            {QUESTION_STATUS.PUBLISHED.value}
          </Typography>
        </Tooltip>
      );
    }
  }

  return (
    <>
      {statusUI}
      <UnpublishQuestionDialog
        openUnpublishDialog={openUnpublishDialog}
        setOpenUnpublishDialog={setOpenUnpublishDialog}
        questionId={question.questionID}
        questionDisplayID={question.displayID}
        handleUnpublish={handleUnpublish}
      />
    </>
  );
};


export default QuestionStatus;
